











































































































import { Component, Vue } from 'vue-property-decorator';

import ColsSvg from '@/assets/icons/cols.svg';

import { Repo } from '@/interfaces/repo';

const columns = [];


export interface Column {
  title: string;
  dataIndex?: string;
  key: string;
  scopedSlots?: { customRender?: string };
  sorter?: (a: unknown, b: unknown) => number;
  filters?: { text?: string; value?: string | number }[];
  onFilter?: (value: string, record: unknown) => boolean;
  order?: number;
}

export interface CheckBoxTarget extends EventTarget {
  checked: boolean;
}
export interface CheckBoxEvent extends Event {
  target: CheckBoxTarget;
}

@Component({
  components: {
    ColsSvg
  }
})
export default class ReposTable extends Vue {
  columns: Column[] = columns;

  groupOptions = [
    {
      label: 'Repo',
      value: 'repo',
      scopedSlots: { customRender: 'repo' },
      order: 11,
      defaultSortOrder: 'ascend',
      sorter: (a: Repo, b: Repo): number => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }
    },
    {
      label: 'PRs',
      value: 'prs',
      scopedSlots: { customRender: 'prs' },
      order: 9,
      defaultSortOrder: 'descend',
      sorter: (a: Repo, b: Repo): number => a.prs.length - b.prs.length
    },
    { label: 'Dev', value: 'dev', scopedSlots: { customRender: 'dev' }, order: 8 },
    {
      label: 'Prod',
      value: 'prod',
      scopedSlots: { customRender: 'prod' },
      order: 8,
      defaultSortOrder: 'descend',
      sorter: (a: Repo, b: Repo): number => a.prod?.diff?.commits?.length - b.prod?.diff?.commits?.length
    }
  ];
  defaultCheckedList = ['repo', 'prs', 'dev', 'prod'];
  indeterminate = true;
  checkAll = false;
  checkedList = this.defaultCheckedList;
  
  get orgUrl(): string {
    return 'https://github.com/' + process.env.VUE_APP_GITHUB_ORG + '/';
  }

  get repos(): Repo[] {
    return this.$store.state.repo.filteredRepos;
  }

  onSearch(value: string): void {
    this.$store.dispatch('repo/filterRepos', { search: value });
  }

  async mounted(): Promise<void> {
    this.$store.dispatch('repo/loadRepos');
    this.updateColumns();
  }

  updateColumns(): void {
    const extraCols = this.checkedList.map((checkedItem) => {
      const option = this.groupOptions.find((groupOption) => {
        return groupOption.value === checkedItem;
      });

      return {
        title: option.label,
        dataIndex: option.value,
        key: option.value,
        ...option
      } as Column;
    });

    const sortedExtraCols = extraCols.sort((a: Column, b: Column): number => b.order - a.order);
    this.columns = [
      ...sortedExtraCols.slice(0, 5),
      ...columns.slice(0, 1),
      ...sortedExtraCols.slice(5, sortedExtraCols.length),
      ...columns.slice(1, columns.length)
    ];
    // slice use to keep sorting of columns
  }

  onColsChange(checkedList: string[]): void {
    this.indeterminate = !!checkedList.length && checkedList.length < this.groupOptions.length;
    this.checkAll = checkedList.length === this.groupOptions.length;
    this.updateColumns();
  }

  onColsCheckAllChange(e: CheckBoxEvent): void {
    this.checkedList = e.target.checked ? this.groupOptions.map((opt) => opt.value) : [];
    this.indeterminate = false;
    this.checkAll = e.target.checked;
    this.updateColumns();
  }

  get tableScrollOpt(): { y: number; x?: number } {
    return { y: window.innerHeight - 230 };
  }
}
